import React, { Component } from 'react';

import { Balloon } from '@icedesign/base';

import { connect } from 'react-redux';

import { formatMessage } from '@/i18n';

const monitorPath = [
  '/',
  '/record/key/outin',
  '/record/lock/switch',
  '/task/list',
  '/record/task/download',
  '/box/hole/list',
  '/cabinet/hole/list',
  '/record/elccabinetdoor/switch',
  '/elccabinet/list',
  '/record/elcalarm',
];
class MQTTMonitor extends Component {
  render() {
    const { mqttConnection, justInteraction, pathname } = this.props;

    return (
      monitorPath.includes(pathname) &&
      mqttConnection && (
        <Balloon
          trigger={
            <div
              className="monitor-signal"
              style={{ backgroundColor: justInteraction ? '#BDBDBD' : '#2ECA9C' }}
            >
              <img src={require('@/images/monitor.png')} style={{ width: '55%' }} />
            </div>
          }
          style={{ borderRadius: 8 }}
          closable={false}
          align="l"
        >
          <div style={{ maxWidth: 180 }}>
            {formatMessage(justInteraction ? 'mqtt.monitor.pause.desc' : 'mqtt.monitoring')}
          </div>
        </Balloon>
      )
    );
  }
}

function mapStateToProps(store) {
  return {
    mqttConnection: store.mqttReducer.connection,
    justInteraction: store.interactionReducer.justInteraction,
  };
}

export default connect(mapStateToProps)(MQTTMonitor);
